export default __webpack_public_path__ + "static/media/kelloggs.f7b88c7a.png";